module.exports = __webpack_public_path__ + "img/ys1.513bf8f1.png";